import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "settings-page-header" }
const _hoisted_2 = { class: "settings-page-header__back-button-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Back", -1 /* HOISTED */)
const _hoisted_4 = { class: "settings-page-header__main-content-wrapper" }
const _hoisted_5 = { class: "settings-page-header__title-content-wrapper" }
const _hoisted_6 = { class: "settings-page-header__actions-block-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "settings-page-header__back-button-wrapper",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_icon, {
          class: "settings-page-header__back-button-icon",
          size: "16"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.Back)))
          ]),
          _: 1 /* STABLE */
        }),
        _hoisted_3
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "title-content")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _renderSlot(_ctx.$slots, "actions-block")
      ])
    ])
  ]))
}